// extracted by mini-css-extract-plugin
export default {"brand":"navbar_brand__9m8Q6","active":"navbar_active__GyOk4","navLink":"navbar_navLink__yn54e"};